import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Container, Button, Box, IconButton, Drawer, List, ListItem, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ActivityTable from './components/ActivityTable';
import ActivityTable2026 from './components/ActivityTable2026';
import About from './components/About';
import HomePage from './components/HomePage';
import PageViewTracker from './components/PageViewTracker';
import './styles/App.css';

function App() {

  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const drawer = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <ListItem button component={Link} to="/">
          <ListItemText primary="Home" />
        </ListItem>
        <ListItem button component={Link} to="/summer-2026">
          <ListItemText primary="Summer 2026" />
        </ListItem>
        <ListItem button component={Link} to="/summer-2025">
          <ListItemText primary="Summer 2025" />
        </ListItem>
        <ListItem button component={Link} to="/about">
          <ListItemText primary="About" />
        </ListItem>
      </List>
    </Box>
  );
  return (
    <Router>
      <PageViewTracker />
      <div className="App">
        <AppBar position="static">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2, display: { sm: 'none' } }}
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Western MA Kids Activities
            </Typography>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <Button color="inherit" component={Link} to="/">Home</Button>
              <Button color="inherit" component={Link} to="/summer-2026">Summer 2026</Button>
              <Button color="inherit" component={Link} to="/summer-2025">Summer 2025</Button>
              <Button color="inherit" component={Link} to="/about">About</Button>
            </Box>
          </Toolbar>
        </AppBar>
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={toggleDrawer(false)}
        >
          {drawer}
        </Drawer>
        <Container>
          <Box my={4}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/summer-2026" element={<ActivityTable2026 />} />
              <Route path="/summer-2025" element={<ActivityTable />} />
              <Route path="/about" element={<About />} />
            </Routes>
          </Box>
        </Container>
      </div>
    </Router>
  );
}

export default App;
